module.exports = __webpack_public_path__ + "assets/4408828aa6c96fdceeea62a0e75314b0.png";